<template>
  <div>
    <div class="card-header">
      <div class="row" style="width: 100%;">
        <div class="col-lg-4">
          <datepicker-input
            :value="filters.from"
            @input="setFrom"
            label="From"
            :stacked="true"
          ></datepicker-input>
        </div>

        <div class="col-lg-4">
          <datepicker-input
            :value="filters.to"
            @input="setTo"
            label="To"
            :stacked="true"
          ></datepicker-input>
        </div>

        <div class="col-lg-4">
          <label class="control-label">
            Driver
          </label>
          <input
            type="text"
            class="form-control"
            :value="filters.terms"
            @input="setTerms($event.target.value)"
          />
        </div>
      </div>
    </div>

    <table class="table">
      <thead>
        <tr>
          <th>Claim Reference</th>
          <th>From</th>
          <th>To</th>
          <th>Collected At</th>
          <th>Mileage Out</th>
          <th>Mileage In</th>
          <!--          <th>Riders</th>-->
          <!--          <th>Delivery Address</th>-->
          <th></th>
        </tr>
      </thead>
      <tbody v-if="hires.length">
        <tr :key="index" v-for="(hire, index) in hires">
          <td>
            <a :href="hire.incident?.url">{{
              hire.incident?.source?.claim_reference
            }}</a>
          </td>
          <td>{{ hire.vehicle?.start_date | date }}</td>
          <td>{{ hire.vehicle?.end_date | date }}</td>
          <td>{{ hire.collection?.date | date }}</td>
          <td>{{ hire.vehicle?.mileage_out || 'Not Provided' }}</td>
          <td>{{ hire.vehicle?.mileage_in || 'Not Provided' }}</td>
          <!--          <td>{{ hire | riders }}</td>-->
          <!--          <td>{{ hire | address }}</td>-->
          <td>
            <router-link
              class="btn btn-primary"
              :to="
                `/deployment/${hire.incident.identifier}/party/${hire.party.identifier}/hire/${hire.identifier}`
              "
            >
              View
            </router-link>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td class="text-center" colspan="5">
            No results
          </td>
        </tr>
      </tbody>
    </table>
    <div class="card-footer text-right" v-if="showPagination">
      <pagination
        :data="paginator_data"
        v-on:updateResults="getData"
      ></pagination>
    </div>
  </div>
</template>
<script>
import debounce from 'lodash/debounce';

export default {
  props: {
    vehicle: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      hires: [],
      paginator_data: null,
      filters: {
        from: '',
        to: '',
        terms: ''
      }
    };
  },

  computed: {
    showPagination() {
      return (
        this.paginator_data?.next_page_url || this.paginator_data?.prev_page_url
      );
    }
  },

  filters: {
    address(hire) {
      return [
        hire.details?.address_line_one,
        hire.details?.address_line_two,
        hire.details?.city,
        hire.details?.postcode
      ]
        .filter(part => !!part)
        .join(', ');
    },

    riders(hire) {
      return hire.drivers.map(driver => driver.name).join(', ');
    }
  },

  mounted() {
    this.loadHires();
  },

  methods: {
    loadHires() {
      this.getData(`/hires?per_page=${this.perPage}`);
    },

    getData(url) {
      Object.keys(this.filters).forEach(key => {
        url = `${url}&filter[${key}]=${this.getFilterValue(key)}`;
      });

      window.Ajax.get(
        `${url}&sort=-from&parts=incident,party,collection&filter[vehicle_id]=${this.vehicle.id}`
      )
        .then(response => {
          this.hires = response.data.data;
          this.paginator_data = response.data;
        })
        .catch(() => {
          window.toastify.error(
            'Error',
            'Sorry, an error occurred while loading the hires'
          );
        });
    },

    getFilterValue(key) {
      const value = this.filters[key];

      if (['from', 'to'].includes(key)) {
        if (value) {
          return window.DateManager.format(value, 'YYYY-MM-DD');
        }
      }

      return value;
    },

    setFrom(from) {
      this.filters.from = from;

      this.loadHires();
    },

    setTo(to) {
      this.filters.to = to;

      this.loadHires();
    },

    setTerms: debounce(function(terms) {
      this.filters.terms = terms;

      this.loadHires();
    }, 400)
  }
};
</script>
